import { api, transformResponse } from './axios'

export const fetchCurrentTime = (token: string) =>
  transformResponse(
    api.get(`/currentTime`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )
